import JassGameState from './gamestate';

/**
 * type fgamestate
 */
export default class JassFGameState extends JassGameState {}
